import '../styles/home.scss';

function Footer(){
  return(
    <div className='footer'>© 2021 Aeromoving S.A.</div>
  );
}

export default Footer;